import { useTranslation } from "react-i18next";

import { noDataAvailableLight, noDataAvailableDark } from "../../../assets";
import { Typography } from "../Typography";
import { cn } from "@/utils";

type TNoRecordMsgProps = {
  msg?: string;
  className?: string;
  justifyParentClass?: string;
  height?: string;
  dataTestId?: string;
};

const CommonNoRecordMsg = ({
  msg,
  className,
  justifyParentClass,
  height,
  dataTestId,
}: TNoRecordMsgProps) => {
  const { t } = useTranslation("common");
  return (
    <>
      <div
        data-testid={dataTestId}
        className={cn(
          "flex flex-col items-center expand-modal-no-records",
          justifyParentClass ?? "justify-center",
          height ?? "h-[250px]",
        )}
      >
        <img
          src={noDataAvailableLight}
          className="no_data_img pt-3 block dark:hidden"
          alt={t("NO_RECORDS_AVAILABLE")}
        />
        <img
          src={noDataAvailableDark}
          className="no_data_img pt-3 hidden dark:block"
          alt={t("NO_RECORDS_AVAILABLE")}
        />
        <Typography
          variant={"p"}
          className={`mt-1 text-gray mb-4 ml-2 ${className ?? ""} dark:text-foreground`}
        >
          {msg ?? t("NO_RECORDS_AVAILABLE")}
        </Typography>
      </div>
    </>
  );
};

export default CommonNoRecordMsg;
